<template>
    <div>
        <div class="caption font-weight-bold material pb-6">
            {{titulo(solucionConstructiva)}}
        </div>

        <div class="12 pa-12 display-1 text-center"
             v-if="indicadoresPrestacionalesDefecto.length == 0 || indicadoresPrestacionalesOtros.length == 0">
            {{$t('cargando_indicadores')}}
            <v-progress-circular
                    indeterminate
                    color="primary"
            ></v-progress-circular>
        </div>

        <div v-if="indicadoresPrestacionalesDefecto.length > 0 && indicadoresPrestacionalesOtros.length > 0">
            <div v-for="(item,i) in indicadoresPrestacionalesDefecto" :key="i">
                <indicador-prestacional
                        :valor-indicador="item"
                        :solucion-constructiva-prestacion="solucionConstructiva.prestacionDermis"
                        v-bind:data="item"
                        v-bind:key="solucionConstructiva.id + item.indicador.id">
                </indicador-prestacional>
            </div>

            <v-btn class="mb-6" :color="!mostrarTodos ? 'primary' : 'secondary'"
                   @click="mostrarTodosIndicadores()">{{textoBoton}}
            </v-btn>

            <div v-show="mostrarTodos">
                <div v-for="(item,i) in indicadoresPrestacionalesOtros" :key="i">
                    <indicador-prestacional
                            :valor-indicador="item"
                            :solucion-constructiva-prestacion="solucionConstructiva.prestacionDermis"
                            v-bind:data="item"
                            v-bind:key="solucionConstructiva.id + item.indicador.id">
                    </indicador-prestacional>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {HttpHelper} from "../../../../../../comunes/helpers/HttpHelper";
    import IndicadorPrestacional from "./Componentes/IndicadorPrestacional";
    import DescripcionesServicio from "../../../../../../comunes/servicios/DescripcionesServicio";

    export default {
        name: "ListadoPrestacionalesComponente",
        props: {
            solucionConstructiva: {type: Object, required: true},
        },
        components: {
            IndicadorPrestacional
        },
        data: () => ({
            dialog: false,
            indicadoresPrestacionalesDefecto: [],
            indicadoresPrestacionalesOtros: [],
            mostrarTodos: false,
            textoBoton: ""
        }),
        mounted() {
            this.inicializarPrestaciones();
            this.cargarIndicadoresPrestacionales();
            this.cambiarTexto();
        },
        watch: {
            solucionConstructiva: {
                handler() {
                    this.inicializarPrestaciones();
                },
                deep: true
            }
        },
        methods: {
            titulo(solCons) {
                return DescripcionesServicio.materialSolCons(solCons);
            },
            inicializarPrestaciones() {
                if (this.solucionConstructiva.prestacionDermis == null) {
                    this.solucionConstructiva.prestacionDermis = {parametros: {}};
                }
            },
            cargarIndicadoresPrestacionales() {
                if (!this.solucionConstructiva) return;

                HttpHelper
                    .get(`solucion-constructiva/${this.solucionConstructiva.id}/indicadores-prestacionales`)
                    .then(valoresIndicadores => {
                        this.cargarIndicadoresPrestacionalesPorDefecto(valoresIndicadores)
                    });
            },
            cargarIndicadoresPrestacionalesPorDefecto(valoresIndicadores) {
                let defecto = [];
                let otros = [];

                HttpHelper
                    .get(`solucion-constructiva/${this.solucionConstructiva.id}/default-indicadores-prestacionales`)
                    .then(indicadoresDefecto => {
                        valoresIndicadores.forEach((valorIndicador) => {
                            if (indicadoresDefecto.includes(valorIndicador.indicador.codigo.toLowerCase())) {
                                defecto.push(valorIndicador);
                            } else {
                                otros.push(valorIndicador);
                            }
                        });
                        this.indicadoresPrestacionalesDefecto = defecto;
                        this.indicadoresPrestacionalesOtros = otros;
                    });
            },
            mostrarTodosIndicadores() {
                this.mostrarTodos = !this.mostrarTodos;
                this.cambiarTexto();
            },
            cambiarTexto() {
                if (!this.mostrarTodos)
                    this.textoBoton = this.$t("mostrar_indi");
                else
                    this.textoBoton = this.$t("ocultar_indi");
            }
        }
    }
</script>

<style scoped>
    .material {
        font-size: 18px !important;
        color: #40108e !important;
        font-weight: 700 !important;
    }
</style>

<!--@formatter:off-->
<i18n>
    {
    "es": {
    "mostrar_indi": "Ver el resto de indicadores",
    "ocultar_indi":"Ocultar el resto de indicadores",
    "descrip_paso":"En esta sección se debe definir las características del proyecto",
    "cerrar":"Cerrar",
    "restaurar_todo":"Restaurar todo",
    "cargando_indicadores":"Cargando indicadores"
    }
    }
</i18n>
<!--@formatter:on-->